import { useQuery } from '@tanstack/react-query';
import { DropdownChangeParams } from 'primereact/dropdown';
import DropdownStyled from '../../../../../components/inputs/StyledInputs/DropdownStyled';
import { useCompanyContext } from '../../../../../context/CompanyContext';
import { JCJobSummary } from '../../../../../Interfaces/Accounting/JobsContracts.interface';
import { fecthJobs } from '../../../../../services/accounting/JobsContractsService';

type JobInputProps = {
  value: string;
  onChange: (e: DropdownChangeParams, isCertified?: boolean) => void;
  disableFetch?: boolean;
};

const JobInput = ({ value, onChange, disableFetch }: JobInputProps) => {
  const { selectedCompany } = useCompanyContext();
  const jobs = useQuery({
    queryKey: ['getPRJobs', selectedCompany],
    queryFn: ({ signal }) =>
      fecthJobs({ companyID: selectedCompany!.id, status: [1] }, signal),
    refetchOnWindowFocus: false,
    enabled: !!selectedCompany && !disableFetch,
  });

  const jobItems =
    jobs.data?.map((job: JCJobSummary) => {
      return { ...job, label: `${job.Job} ${job.Description}` };
    }) ?? [];
  jobItems?.unshift({
    label: 'N/A',
    Job: 'N/A',
    Description: '',
    Certified: false,
  });
  const selectedInfo = jobItems.find((job: JCJobSummary) => job.Job === value);

  return (
    <span className="w-full h-full">
      <DropdownStyled
        options={jobItems}
        labelField="label"
        valueField="Job"
        isLoading={jobs.isLoading}
        error={jobs.isError}
        className="h-full printHide"
        filter={true}
        value={value}
        onChange={(event) => {
          const selectedJob = event.value;
          const job = jobs.data?.find(
            (job: JCJobSummary) => job.Job === selectedJob
          );
          onChange(event, job?.Certified);
        }}
        absoluteLabel={true}
        showRestricted={!!value && !selectedInfo}
      />
      <span className="printMedia printShow">{selectedInfo?.label}</span>
    </span>
  );
};

export default JobInput;
